import { render, staticRenderFns } from "./ChangePassword.component.vue?vue&type=template&id=002fdab6&"
import script from "./ChangePassword.component.vue?vue&type=script&lang=ts&"
export * from "./ChangePassword.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports